module.exports = __webpack_public_path__ + "static/media/backgroundProduct.21d1a238.jpg";